export default __webpack_public_path__ + "static/media/151-entrance.aec40d08.png";